<script>
import * as API from '../api/followers';

export default {
    name: 'CpMembers',
    components: {
        CpBox: require('../box').default,
        CpGrid: require('../grid').default,
        CpGridItem: require('../grid-item').default,
        CpMember: require('./posts/member').default,
        InfiniteLoading: require('vue-infinite-loading').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        scrollToTop: require('../mixins/utils.js').default,
    },
    directives: {
        margin: require('../directives/margins').margin,
        marginTop: require('../directives/margins').marginTop,
        marginRight: require('../directives/margins').marginRight,
        marginBottom: require('../directives/margins').marginBottom,
        marginLeft: require('../directives/margins').marginLeft
    },
    props: {
        currentUser: { type: Object },
        query: { type: String },
        tags: { type: Array },  
        connections: { type: String },        
    },
    data: () => ({
        members: [],
        page: 0,
        searching: null,        
    }),    
    watch: {
        query: {
            handler(newValue, oldValue) {
                if (!this.$root.isMobile) {
                    this.scrollToTop();
                }
                if (this.searching) {
                    clearTimeout(this.searching);
                }
                this.searching = setTimeout(() => {
                    this.page = 0;
                    this.members = [];
                    this.searching = null;
                }, 500);
            }
        },
        tags: {
            handler(newValue, oldValue) {
                if (!this.$root.isMobile) {
                    this.scrollToTop();
                }
                if (this.searching) {
                    clearTimeout(this.searching);
                }
                this.searching = setTimeout(() => {
                    this.page = 0;
                    this.members = [];
                    this.searching = null;
                }, 500);
            }
        },
        connections: {
            handler(newValue, oldValue) {
                if (this.searching) {
                    clearTimeout(this.searching);
                }
                this.searching = setTimeout(() => {
                    this.page = 0;
                    this.members = [];
                    this.searching = null;
                }, 500);
            }
        },
    },
    methods: {
        fetch($state) {
            API.index({ page: this.page, query: this.query, tags: this.tags, connections: this.connections })
                .then(response => {
                    if (response.length) {
                        this.members = this.members.concat(response);
                        this.page += 1;
                        if ($state) $state.loaded();
                    } else {
                        if ($state) $state.complete();
                    }
                })
                .catch(error => {
                    if ($state) $state.complete();
                    console.warn(error);
                });
        },
        
    }
};
</script>

<template>
    <cp-box>
        <transition-group name="feed-fade">
            <cp-member v-for="member in members" :key="member.slug" :member="member" :current-user="currentUser" :connections ="connections"/>
        </transition-group>
        <transition name="feed-fade" mode="out-in">
            <div class="heading-4 text-center" v-if="searching" key="searching">
                <vue-simple-spinner v-margin="1" />
            </div>
            <infinite-loading @infinite="fetch" v-margin="1" v-else key="scrolling">
                <div slot="spinner">
                    <div class="heading-4">
                        <vue-simple-spinner v-margin="1" />
                    </div>
                </div>
                <div slot="no-more">
                    <div class="heading-4">That's all!</div>
                </div>
                <div slot="no-results">
                    <div class="heading-4">We couldn't find any member that matches {{this.query}} </div>
                </div>
            </infinite-loading>
        </transition>
    </cp-box>
</template>
